const BUILDER_ICON_BASE_PATH = '/public-assets/builders';
const builderIconUrl = (fileName: string) => `${BUILDER_ICON_BASE_PATH}/${fileName}`;

const axiom = builderIconUrl('axiom.png');
const defiapp = builderIconUrl('defiapp.png');
const dexari = builderIconUrl('dexari.png');
const hypurrdash = builderIconUrl('hyperdash.png');
const insilico = builderIconUrl('insilico.png');
const lootbase = builderIconUrl('lootbase.png');
const okto = builderIconUrl('okto.png');
const okutrade = builderIconUrl('okutrade.png');
const purps = builderIconUrl('purps.png');
const pvp = builderIconUrl('pvp.png');
const superx = builderIconUrl('superx.png');
const topdog = builderIconUrl('topdog.png');
const kinto = builderIconUrl('kinto.png');
const gtrdottrade = builderIconUrl('gtrdottrade.png');
const pearprotocol = builderIconUrl('pearprotocol.png');
const liquid = builderIconUrl('liquid.png');
const basedapp = builderIconUrl('basedapp.png');
const walletv = builderIconUrl('walletv.png');
const dextrabot = builderIconUrl('dextrabot.png');
const apexliquid = builderIconUrl('apexliquid.png');
const mass = builderIconUrl('mass.png');
const supercexy = builderIconUrl('supercexy.png');
const coinpilot = builderIconUrl('coinpilot.png');
const dreamcash = builderIconUrl('dreamcash.png');
const pulsetrader = builderIconUrl('pulsetrader.png');
const hlbot = builderIconUrl('hlbot.png');
const ranger = builderIconUrl('ranger.png');
const rabbywallet = builderIconUrl('rabbywallet.png');
const lit = builderIconUrl('lit.png');
const liminal = builderIconUrl('liminal.png');
const hyperx = builderIconUrl('hyperx.png');
const bullpen = builderIconUrl('bullpen.png');
const jester = builderIconUrl('jester.png');
const rainbow = builderIconUrl('rainbow.png');
const coin98 = builderIconUrl('coin98.png');
const infinex = builderIconUrl('infinex.png');
const metamask = builderIconUrl('metamask.png');
const splash = builderIconUrl('splash.png');
const gem_wallet = builderIconUrl('gem_wallet.png');
const crypto_therapy = builderIconUrl('crypto_therapy.png');
const hyper_signals = builderIconUrl('hyper_signals.png');
const uxuy = builderIconUrl('uxuy.png');
const wunder_trading = builderIconUrl('wunder_trading.png');
const superstack = builderIconUrl('superstack.png');
const origami_tech = builderIconUrl('origami.png');
const treadfi = builderIconUrl('treadfi.png');
const echoSync = builderIconUrl('echosync.png');
const fomo = builderIconUrl('fomo.png');
const fomo_2 = builderIconUrl('fomo_2.png');
const supurrapp = builderIconUrl('supurrapp.png');
const coinrule = builderIconUrl('coinrule.png');
const doblox = builderIconUrl('doblox.png');
const bloxwap = builderIconUrl('bloxwap.png');
const evplus = builderIconUrl('evplus.png');
const cipher = builderIconUrl('cipher.png');
const tidal = builderIconUrl('tidal.png');
const senpri = builderIconUrl('senpri.png');
const cwallet = builderIconUrl('cwallet.png');
const crotrade = builderIconUrl('crotrade.png');
const goldenpig = builderIconUrl('goldenpig.png');
const limits = builderIconUrl('limits.png');
const dexly = builderIconUrl('dexly.png');
const onekey = builderIconUrl('onekey.png');
const hyprearn = builderIconUrl('hyperearn.png');
const atomic = builderIconUrl('atomic.png');
const naked = builderIconUrl('naked.png');
const coinbob = builderIconUrl('coinbob.png');
const minaraai = builderIconUrl('minaraai.png');
const xbit = builderIconUrl('xbit.png');
const openpond = builderIconUrl('openpond.png');
const miracle = builderIconUrl('miracle.png');
const tria = builderIconUrl('tria.png');
const markets = builderIconUrl('markets.png');
const planemo = builderIconUrl('planemo.png');
const mmt = builderIconUrl('mmt.png');
const moonbot = builderIconUrl('moonbot.png');
const velo = builderIconUrl('velo.png');
const alura = builderIconUrl('alura.png');
const sendai = builderIconUrl('sendai.png');
const vibeliquid = builderIconUrl('vibeliquid.png');
const vergex = builderIconUrl('vergex.png');
const invo = builderIconUrl('invo.png');
const borsa = builderIconUrl('borsa.png');
const trustwallet = builderIconUrl('trustwallet.png');
const legend = builderIconUrl('legend.png');
const tonx = builderIconUrl('tonx.png');
const sushiswap = builderIconUrl('sushiswap.png');
const defiserver = builderIconUrl('defisaver.png');
const blockchain = builderIconUrl('blockchain.png');
const onyx = builderIconUrl('onyx.png');
const tradoor = builderIconUrl('tradoor.png');
const truenorth = builderIconUrl('truenorth.png');
const liquidbot = builderIconUrl('liquidbot.png');
const nearcom = builderIconUrl('nearcom.png');
const nansen = builderIconUrl('nansen.png');
const trasia = builderIconUrl('trasia.png');
const root_ai = builderIconUrl('root_ai.png');
const order_x = builderIconUrl('order_x.png');
const azali = builderIconUrl('azali.png');
const greevils_ai = builderIconUrl('greevils_ai.png');
const seabond = builderIconUrl('seabond.png');
const questflow = builderIconUrl('questflow.png');
const sogo = builderIconUrl('sogo.png');
const hypeRank = builderIconUrl('hyperank.png');
const proliquid = builderIconUrl('proliquide.png');
const aping = builderIconUrl('aping.png');
const snappyTrade = builderIconUrl('snappy_trade.png');
const hyperLink = builderIconUrl('hyperlink.png');
const stablejack = builderIconUrl('stablejack.png');
const entropyio = builderIconUrl('entropyio.png');
const outcome = builderIconUrl('outcome.png');
const atlasx = builderIconUrl('atlasx.png');
const traderWars = builderIconUrl('trader_wars.png');
const liquary = builderIconUrl('liquary.png');
const godelTerminal = builderIconUrl('godel_terminal.png');
const quote = builderIconUrl('quote.png');
const gte = builderIconUrl('gte.png');
const silhoutte = builderIconUrl('silhoutte.png');
const onchainCc = builderIconUrl('onchain_cc.png');
const totalis = builderIconUrl('totalis.png');
const hyperTrend = builderIconUrl('hypertrend.png');
const bitso = builderIconUrl('bitso.png');
const arx = builderIconUrl('arx.png');
export const UNKNOWN_BUILDER_ICON = builderIconUrl('unknown_builder.png');

export const buildersDataByAddress = {
    '0xcf56dd84ed85eb4929e0a76a0f2f04049b4ffc1a': {
        icon: infinex,
        color: '#FF6E39',
        name: 'Infinex',
    },
    '0x3342ee6851ef0ec3cf42658c2be3b28a905271aa': {
        icon: coin98,
        color: '#F0C43F',
        name: 'Coin98',
    },
    '0x60dc8e3dad2e4e0738e813b9cb09b9c00b5e0fc9': {
        icon: rainbow,
        color: '#FFAE00',
        name: 'Rainbow',
    },
    '0x786a53cbf73dd90fd6f2b4cf9514b60c8411dca7': {
        icon: jester,
        color: '#4E258E',
        name: 'Jester',
    },
    '0xc74812f67eddaf2f3aed6e061eaa9168b36d7ea1': {
        icon: hyperx,
        color: '#C0DDFF',
        name: 'HyperX',
    },
    '0x4c8731897503f86a2643959cbaa1e075e84babb7': {
        icon: bullpen,
        color: '#FFFFFF',
        name: 'Bullpen',
    },
    '0x24a747628494231347f4f6aead2ec14f50bcc8b7': {
        icon: lit,
        color: '#E30BFD',
        name: 'Lit',
    },
    '0xad9be64fd7a35d99a138b87cb212baefbcdcf045': {
        icon: rabbywallet,
        color: '#4C65FF',
        name: 'Rabby',
    },
    '0xf5bc9107916b91a3ea5966cd2e51655d21b7eb02': {
        icon: ranger,
        color: '#CCFF9A',
        name: 'Ranger',
    },
    '0x52d8b948e300bd30097af941e937837e6fbb7a8a': {
        icon: hlbot,
        color: '#97FCE4',
        name: 'HLBot ',
    },
    '0x151e3af3c2387a2138ccc684d1d1d78277db68a9': {
        icon: pulsetrader,
        color: '#96FCE4',
        name: 'PulseTrader',
    },
    '0x4950994884602d1b6c6d96e4fe30f58205c39395': {
        icon: dreamcash,
        color: '#1698F6',
        name: 'Dreamcash',
    },
    '0xe9935bb291ab3603b4d7862e6f19315f759aa3a4': {
        icon: coinpilot,
        color: '#D3E3B6',
        name: 'Coinpilot',
    },
    '0xf944069b489f1ebff4c3c6a6014d58cbef7c7009': {
        icon: mass,
        color: '#EAFF42',
        name: 'Mass',
    },
    '0xb84168cf3be63c6b8dad05ff5d755e97432ff80b': {
        icon: purps,
        color: '#9886E5',
        name: 'Phantom',
    },
    '0x2868fc0d9786a740b491577a43502259efa78a39': {
        icon: insilico,
        color: '#00CC99',
        name: 'Insilico',
    },
    '0x0cbf655b0d22ae71fba3a674b0e1c0c7e7f975af': {
        icon: pvp,
        color: '#CBCBCB',
        name: 'PVP',
    },
    '0x1cc34f6af34653c515b47a83e1de70ba9b0cda1f': {
        icon: axiom,
        color: '#202A62',
        name: 'Axiom',
    },
    '0xc1f4d15c16a1f3555e0a5f7aefd1e17ad4aaf40b': {
        icon: kinto,
        color: '#636363',
        name: 'Kinto',
    },
    '0xe966a12bf7b93838096e4519a684519ab22df618': {
        icon: hypurrdash,
        color: '#EE3602',
        name: 'Hyperdash',
    },
    '0x5ef4deeb76f87d979d0ddc8c51f5b4f65d1c972a': {
        icon: gtrdottrade,
        color: '#3982FF',
        name: 'GTR.Trade',
    },
    '0x3e0ef9ad4096c30acefbf7a996f4c19edd071286': {
        icon: lootbase,
        color: '#13F879',
        name: 'Lootbase',
    },
    '0x4ecd58def11dc3cadf7deb09f27da69d5475acb3': {
        icon: superx,
        color: '#98FEE0',
        name: 'SuperX',
    },
    '0x7975cafdff839ed5047244ed3a0dd82a89866081': {
        icon: dexari,
        color: '#FAFAFA',
        name: 'Dexari',
    },
    '0xaef63e8441987a5e9bf1d37ebb61d8855f405a98': {
        icon: topdog,
        color: '#C7E757',
        name: 'TopDog',
    },
    '0xa47d4d99191db54a4829cdf3de2417e527c3b042': {
        icon: pearprotocol,
        color: '#3EB750',
        name: 'Pear Protocol ',
    },
    '0x3dca96c1facc33d41c71488662817c70a626ac9d': {
        icon: pearprotocol,
        color: '#3EB750',
        name: 'Pear Protocol ',
    },
    '0x6d4e7f472e6a491b98cbeed327417e310ae8ce48': {
        icon: liquid,
        color: '#FAFAFA',
        name: 'Liquid',
    },
    '0x0000000bfbf4c62c43c2e71ef0093f382bf7a7b4': {
        icon: supercexy,
        color: '#ACF601',
        name: 'SuperCexy',
    },
    '0x1924b8561eef20e70ede628a296175d358be80e5': {
        icon: basedapp,
        color: '#FE693F',
        name: 'Based',
    },
    '0x68c68ba58f50bdbe5c4a6faf0186b140eab2b764': {
        icon: walletv,
        color: '#896CEC',
        name: 'Wallet V',
    },
    '0x49ae63056b3a0be0b166813ee687309ab653c07c': {
        icon: dextrabot,
        color: '#FF3DFD',
        name: 'Dextrabot',
    },
    '0xe1f55f2f25884c2ddc86b6f7efa5f45b2ef04221': {
        icon: apexliquid,
        color: '#80F0B8',
        name: 'Apexliquid',
    },
    '0x05984fd37db96dc2a11a09519a8def556e80590b': {
        icon: okto,
        color: '#3672E1',
        name: 'Okto',
    },
    '0x4fe1141b9066f3777f4bd4d4ac9d216173031dc1': {
        icon: okto,
        color: '#3672E1',
        name: 'Okto',
    },
    '0xd637f2a36c1a3b37d57ef4c7022cb183d8922f2c': {
        icon: okutrade,
        color: '#FFFFFF',
        name: 'Oku Trade',
    },
    '0x1922810825c90f4270048b96da7b1803cd8609ef': {
        icon: defiapp,
        color: '#EFF4EF',
        name: 'Defiapp',
    },
    '0x7e1830b1796b01f2f6a7118d50d4d02491421f32': {
        icon: liminal,
        color: '#D7D7D7',
        name: 'Liminal',
    },
    '0xe95a5e31904e005066614247d309e00d8ad753aa': {
        icon: metamask,
        color: '#FF8D5D',
        name: 'MetaMask',
    },
    '0xea2c82b5aba243ab631c0ce151763d5e38df75b3': {
        icon: metamask,
        color: '#FF8D5D',
        name: 'MetaMask',
    },
    '0x3f24962739e6d703942dc2456e7c51c8d0ca4b70': {
        icon: splash,
        color: '#383838',
        name: 'Splash',
    },
    '0x0d9dab1a248f63b0a48965ba8435e4de7497a3dc': {
        icon: gem_wallet,
        color: '#2D5BE5',
        name: 'Gem Wallet',
    },
    '0x67b642d2c19b4cb20681c997180ddd124e3c83ef': {
        icon: crypto_therapy,
        color: '#FFFFFF',
        name: 'CryptoTherapy',
    },
    '0x75982eb8b734b24b653b39e308489a428041f162': {
        icon: wunder_trading,
        color: '#2070F9',
        name: 'WunderTrading',
    },
    '0x2e266a0f40e9f5bca48f5df1686aab10b1b68ec8': {
        icon: uxuy,
        color: '#FE4300',
        name: 'UXUY',
    },
    '0x8af3545a3988b7a46f96f9f1ae40c0e64fa493c2': {
        icon: hyper_signals,
        color: '#FF5A20',
        name: 'HyperSignals',
    },
    '0xcdb943570bcb48a6f1d3228d0175598fea19e87b': {
        icon: superstack,
        color: '#0092FF',
        name: 'Superstack',
    },
    '0x9b451f8941240db8bedc99bff8917a2ed9550074': {
        icon: origami_tech,
        color: '#8B68A1',
        name: 'Origami Tech',
    },
    '0x999a4b5f268a8fbf33736feff360d462ad248dbf': {
        icon: treadfi,
        color: '#D56225',
        name: 'Tread.Fi',
    },
    '0x831ad7eb3e600a3ab8df851ce27df8d8dd6b5d9c': {
        icon: echoSync,
        color: '#F3F4F6',
        name: 'EchoSync',
    },
    '0xb838e4d1c8bcf71fa8e63299d5aa3258c83d6adb': {
        icon: fomo,
        color: '#CCF115',
        name: 'FOMO',
    },
    '0x2a2b6b093a9813fbd8cddae800c3d17d46460d17': {
        icon: fomo_2,
        color: '#EAEDFF',
        name: 'fomo',
    },
    '0x36be02a397e969e010ccbd7333f4169f66b8989f': {
        icon: supurrapp,
        color: '#4EA03E',
        name: 'Supurr.app',
    },
    '0xb5f659ffe0d3d2a72e63189bab89de716ac502c4': {
        icon: coinrule,
        color: '#FFDA10',
        name: 'Coinrule',
    },
    '0xc0a6dd2bbb7e0b29b51e191e6343fa17fdc0d393': {
        icon: doblox,
        color: '#FEC200',
        name: 'Doblox',
    },
    '0x71b09a08257078a4d642f7dd7315e656c837329a': {
        icon: bloxwap,
        color: '#00FF01',
        name: 'Bloxwap',
    },
    '0xc1a2f762f67af72fd05e79afa23f8358a4d7dbaf': {
        icon: evplus,
        color: '#00BF62',
        name: 'EVplusAI',
    },
    '0x32f6940795d6d484a6d29b6b628ebaff80a0c779': {
        icon: cipher,
        color: '#40C1E5',
        name: 'Cipher',
    },
    '0x4752f5d4ea2bd35ec257228074053f19bdb41e8c': {
        icon: tidal,
        color: '#A5DBD1',
        name: 'Tidal',
    },
    '0x1368f4311db5807f7c7924d736adaeb83e47bafe': {
        icon: senpri,
        color: '#3D59EB',
        name: 'Senpi',
    },
    '0xb977b6625dfe3d26eefa4ac6f99ada6546586962': {
        icon: cwallet,
        color: '#62F4A3',
        name: 'Cwallet',
    },
    '0x008adf65b8c404e8bba73f18671306066643761f': {
        icon: crotrade,
        color: '#1A1A1A',
        name: 'cro.trade',
    },
    '0x43f2dc9fd6ce4ee15ae5525a97211fe229d5d140': {
        icon: goldenpig,
        color: '#FFEB98',
        name: 'goldenpig.xyz',
    },
    '0x746337a98821e1e38aa2bad0e77900d98b80609e': {
        icon: limits,
        color: '#42EE74',
        name: 'Limits',
    },
    '0x70cf605bb180daf00c3e2f1ca3df5bb602664452': {
        icon: hyprearn,
        color: '#F8BB08',
        name: 'HyprEarn',
    },
    '0x22047776933bc123d0602ed17aaf0d2f5647df0c': {
        icon: dexly,
        color: '#23CFE7',
        name: 'Dexly',
    },
    '0x9b12e858da780a96876e3018780cf0d83359b0bb': {
        icon: onekey,
        color: '#44D62D',
        name: 'OneKey',
    },
    '0x53a1954188fc9bf2edb45b94450100507b92fcd1': {
        icon: atomic,
        color: '#3FBCFE',
        name: 'Atomic',
    },
    '0x5d2c2bd98f10616771d7b5124ad2090ba72aa43c': {
        icon: naked,
        color: '#FAFFFF',
        name: 'Silhouette (Naked)',
    },
    '0xfac5de987335d35f0fee81b19ec63d67f33a6d5a': {
        icon: coinbob,
        color: '#03498B',
        name: 'Coinbob',
    },
    '0x5a3bc60b0a99a7f4fbf0d15554fa5fe88e7628c2': {
        icon: minaraai,
        color: '#FAF9F5',
        name: 'Minara AI',
    },
    '0x0c322f69ab8d0544be3cfd54424762a4251806c5': {
        icon: xbit,
        color: '#9035F4',
        name: 'XBIT',
    },
    '0x4b2aec4f91612849d6e20c9c1881fabb1a48cd12': {
        icon: openpond,
        color: '#FFFFFF',
        name: 'OpenPond AI',
    },
    '0x5eb46bfbf7c6004b59d67e56749e89e83c2caf82': {
        icon: miracle,
        color: '#92D2F6',
        name: 'Miracle',
    },
    '0x9f83fe01f4a62d44e8ca471e2eeb42b5c05531d9': {
        icon: tria,
        color: '#FFFFFF',
        name: 'Tria',
    },
    '0x42f3226007290b02c5a0b15bccbb1ba6df04f992': {
        icon: markets,
        color: '#FCFCFD',
        name: 'Markets Terminal',
    },
    '0x2af94a24e1f744a8e251b4996283ffb4657e915d': {
        icon: markets,
        color: '#FCFCFD',
        name: 'Markets Mobile',
    },
    '0x12c50cb693dfb1ee8c2a71bbbac883ae79dac9de': {
        icon: planemo,
        color: '#0260BD',
        name: 'Planemo',
    },
    '0xdc29d8532fb6f263e236b304c4b3349cc301048b': {
        icon: mmt,
        color: '#FFFFFF',
        name: 'MMT',
    },
    '0xb84c7fb41ee7d8781e2b0d59eed2accd2ae99533': {
        icon: moonbot,
        color: '#002A38',
        name: 'Moonbot',
    },
    '0x5d3551942be7630a9b988a32208ac9c1d1a49ce6': {
        icon: velo,
        color: '#FFFFFF',
        name: 'Velo',
    },
    '0x29b4b7a5e16332b7a09369d32b262d07741f0442': {
        icon: alura,
        color: '#91F980',
        name: 'Alura',
    },
    '0xd58ee5dc9cb03df60843c6234644aa535b08a8b9': {
        icon: sendai,
        color: '#FFFFFF',
        name: 'SendAI',
    },
    '0x4c13d871aa1862a3c60407bb9e01b20bf1e2fede': {
        icon: vibeliquid,
        color: '#ADCEC5',
        name: 'VibeLiquid',
    },
    '0x891dc6f05ad47a3c1a05da55e7a7517971faaf0d': {
        icon: vergex,
        color: '#796BF5',
        name: 'VergeX',
    },
    '0x557edb253b1d7ed5f15b248a5a3fd919fa5d3c81': {
        icon: invo,
        color: '#3242FE',
        name: 'Invo',
    },
    '0x74c362cd3a141769f38c48d66ee51b1938ea4bd0': {
        icon: borsa,
        color: '#059750',
        name: 'Borsa',
    },
    '0x5af1b5f44207784dcb850bbb4143c5dcd1885f71': {
        icon: trustwallet,
        color: '#0500FF',
        name: 'Trust Wallet',
    },
    '0x4e65de9ca0abe3d36f7e3d7a7ce9f0dbe406a412': {
        icon: legend,
        color: '#FFA719',
        name: 'Legend',
    },
    '0xc894754cc9434854a9eaceeb3f797fb2ae74f5a0': {
        icon: tonx,
        color: '#0099EB',
        name: 'Tonx Trade',
    },
    '0x12ee177db3ceafedc639d023a29cc8588db3a4b9': {
        icon: sushiswap,
        color: '#F952A0',
        name: 'Sushiswap',
    },
    '0x40e9d9feba3df27e1fb9a924264bf775230d5260': {
        icon: defiserver,
        color: '#49AA67',
        name: 'DeFi Saver',
    },
    '0xdbc27ea7aa99274026404b2fa21114815d9997a6': {
        icon: blockchain,
        color: '#DA133E',
        name: 'Blockchain',
    },
    '0xb290f2f3fad4e540d0550985951cdad2711ac34a': {
        icon: onyx,
        color: '#CCFF01',
        name: 'Onyx',
    },
    '0x92345453ce2000642d7d4ceeae4fccc6c2e41d23': {
        icon: tradoor,
        color: '#921F07',
        name: 'Tradoor',
    },
    '0x30599f69164b854a2c10ada95e5cd219b72d5216': {
        icon: truenorth,
        color: '#2C94FD',
        name: 'TrueNorth',
    },
    '0xfb2b33c56e1f69a92a048867b3400860f190244b': {
        icon: liquidbot,
        color: '#0A1628',
        name: 'My Liquid Bot',
    },
    '0xf85a61857c0682b9b59d562310df106b4f785688': {
        icon: nearcom,
        color: '#0EEFA3',
        name: 'near.com',
    },
    '0x93053f1e7a5efeda532fe69cbbe43cbec3a0f13f': {
        icon: nansen,
        color: '#01FFA7',
        name: 'Nansen',
    },
    '0x8e67f9edc39051d01943cfed122c8ae76bd45ca7': {
        icon: order_x,
        color: '#7BD1E7',
        name: 'OrderX',
    },
    '0x42519c03009d4148179178178980a73006837bd4': {
        icon: root_ai,
        color: '#F3F3F3',
        name: 'rootAI',
    },
    '0xa9300365e8f6d0112a756c98f9acfc3543b295c0': {
        icon: trasia,
        color: '#FF1BD8',
        name: 'Trasia',
    },
    '0x4a649fa98072c21d59fcef68e955f23be6b8dfdb': {
        icon: azali,
        color: '#2DC777',
        name: 'Azali',
    },
    '0x61392f079ad07acb67bfc056886099ac06a881e1': {
        icon: greevils_ai,
        color: '#93CA17',
        name: 'Greevils AI',
    },
    '0xf341a8010cbf7834eb3008ef80daab10643797ef': {
        icon: seabond,
        color: '#894BFE',
        name: 'Seabond',
    },
    '0xf550b281d21986a5616a3dd0e8873546d491db60': {
        icon: questflow,
        color: '#266E7A',
        name: 'Questflow',
    },
    '0x980adfdcb7655198ea69d2e19eb7daca594a9e67': {
        icon: sogo,
        color: '#00E289',
        name: 'SOGO Terminal',
    },
    '0x860343ba897f44a9a87353d93795f417b9a22226': {
        icon: hypeRank,
        color: '#91D5D4',
        name: 'hypeRank',
    },
    '0x00000000617c4307d352e8c1720a9f29d01c3d62': {
        icon: proliquid,
        color: '#01DCEF',
        name: 'Proliquid',
    },
    '0x4f8428ece2e07ac544ac1d0de0988930d0c662e3': {
        icon: aping,
        color: '#FFF',
        name: 'Aping',
    },
    '0xa88bbed68185eea4faffcba0463106c2ca265169': {
        icon: snappyTrade,
        color: '#D4EF02',
        name: 'Snappy Trade',
    },
    '0xe66eafbfe28155cc735170317ae5d0bf818f68ef': {
        icon: hyperLink,
        color: '#1B3EE0',
        name: 'HyperLink',
    },
    '0x68b7e8be8f1a62f99e37f1ac191dd23486e8a2ad': {
        icon: stablejack,
        color: '#CEE828',
        name: 'StableJack',
    },
    '0xcd254d2a328f7f67c7c6fef930a4757516f7b601': {
        icon: entropyio,
        color: '#F2F1EF',
        name: 'Entropy.io',
    },
    '0xab5dbc057628bc18523c4cdfc0e1e2ebdbecb704': {
        icon: outcome,
        color: '#DEDFD7',
        name: 'Outcome',
    },
    '0x83018fdfc5c25453611a9f5e3389a9735030629c': {
        icon: atlasx,
        color: '#FEFEFE',
        name: 'ATLASX',
    },
    '0x2d3351f39267610f17b867603de28d571c7f7eaa': {
        icon: traderWars,
        color: '#E7F3FF',
        name: 'TraderWars',
    },
    '0xc9200c6d0e876d5f63c76618f2c57e5d6a080927': {
        icon: liquary,
        color: '#FFF',
        name: 'Liquary',
    },
    '0xd055a509ec9b09889386ac4e4b10056d3573e1ff': {
        icon: godelTerminal,
        color: '#FFFFFF',
        name: 'Godel Terminal',
    },
    '0x459b632f49023881cd45d8f0003297ebe16a13d6': {
        icon: quote,
        color: '#ACABAB',
        name: 'Quote',
    },
    '0x09db8a3500c63c4792c171b6b15eb8635e3638f1': {
        icon: gte,
        color: '#FFFFFF',
        name: 'GTE',
    },
    '0xbb894903e2ca4929f1cfd6fd7f17859e4b81c80c': {
        icon: silhoutte,
        color: '#94fff9',
        name: 'Silhoutte',
    },
    '0x64c06812904d342367ad155d7a8f3b7c7fb27f5f': {
        icon: onchainCc,
        color: '#9797F8',
        name: 'onchain.cc',
    },
    '0x334fd4455dde94f36dd2a7c4041992ddc8407dc5': {
        icon: totalis,
        color: '#FFFFFF',
        name: 'Totalis',
    },
    '0x9aab0c4de7b6eadf5866335095594ee83c0735ad': {
        icon: hyperTrend,
        color: '#58FEF0',
        name: 'HyperTrend',
    },
    '0x73f097297d8045fa2f6d2548272761d68dbe7199': {
        icon: bitso,
        color: '#7E89FF',
        name: 'bitso',
    },
    '0x2165f1023f7584d0ba251808895e3011fcbbd9c7': {
        icon: arx,
        color: '#E9EAFE',
        name: 'ARX',
    },
};

const additionalBuilderNamesForAutocomplete = [
    'SuperCexy',
    'cro.trade',
    'Okto',
    'XBIT',
    'PVP',
    'MomoAI',
    'Kuru',
    'Rage Trade',
    'Enzyme',
    'Upshift',
    'Nucleus',
    'Tholgar',
    'Pulsar',
    'GTE',
    'Blueberry',
    'Aries',
    'GTE',
    'Tren Finance',
    'Felix',
    'Valve',
    'Ambient',
    'HyperLend',
    'Aster',
    'Liminal',
    'BitVault',
    'Sentiment',
    'Ethereal',
    'Mizu',
    'Delta Neutral',
    'Hyperbeat',
    'Felix',
    'Kinetiq',
    'Cabal',
    'Harmonix',
    'Timeswap',
    'Abacus',
    'Liminal',
    'Meow',
    'Keiko',
    'Cork',
    'Valantis',
    'Unit',
    'Thunderhead',
    'Ostium',
    'Sophon',
    'HyperLend',
    'SIR',
    'Mizu',
    'Rysk',
    'Superform',
    'Demex',
    'Hyperdrive',
    'Reservoir',
    'HyperSwap',
    'HypurrFi',
    'Veda',
    'Aspecta',
    'Origami',
    'f(x) Protocol',
    'HyperBeat',
    'LoopedHYPE',
    'Kinetiq',
    'Resolv',
    'Cap',
    'Orochi',
    'HyBridge',
    'SuperX',
    'GainBridge',
    'Project X',
    'Magma',
    'Lair',
    'Sake Finance',
    'Liminal',
    'Hypio',
    'Rooster',
    'L1',
    'Pike',
    'Sentiment',
    'Laminar',
    'Blueprint',
    'Aster',
    'Pulsar',
    'Fugazi',
    'Brahma',
    'Liminal',
    'Monadex',
    'Mosaic',
    'Kyan',
    'Morpheus',
    'Turtle.Club',
    'D2',
    'Drift',
    'Torus',
    'HyperBloom',
    'Aori',
    'LogX',
    'Particle',
    'Contour',
    'Elys',
    'Felix',
];

export const buildersNamesForAutocomplete = Array.from(
    new Set([
        ...Object.values(buildersDataByAddress).map((builder) => builder.name),
        ...additionalBuilderNamesForAutocomplete,
    ]),
);
